module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAABJklEQVQokY3SIW9UURAF4G9fuwRNa/oLVlU3IekTJJgmrKnqT6jDLmMQO9RiGgQOQ9KwZvkHe1UVAlVX06wpBI15iL0vednQpsfczJx7bu6ZOaOu6/TIzAnO0eIFfmOFTxFx098bdV0nM0eY4T0WWGKNA0xxWrmLiOiaKp7hLY4j4qwKbyPia62PKz+DnfF4PMEVXkfENZRSTnDZtu1naNv2rpSywpdSylVTPSx6QcUOxoNa5Rc4b6rppadhibbBXjW9jeeZubvVW2O/wa86pSGu8Qc/MvPVoH+A+8ZmD9Ot/6/xEpf4lplHlZpiNZrP5xP8tBn3cBggM59FxN8qLDjsl/vOZg9vHhAe4Ts+RsSH3uhFPUtmPpoIaowGLw6zt497/8nePys+c3Wmonz5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/freeRunning-time.png
// module id = Tn+z
// module chunks = 1